import React from 'react';
import { youtubeId } from '../lib/youtube';

export default function RaceVideo({ url }: { url: string }) {
  const id = youtubeId(url);
  if (!id) return <p className="text-xs text-gray-400">Grabación pendiente de publicación en YouTube.</p>;
  return <div className="space-y-4">
    <p className="text-cyan-300 text-xs uppercase tracking-wide">Grabación de Carrera</p>
    <iframe
      title="Grabación de la carrera TurVolt"
      src={`https://www.youtube.com/embed/${id}?playsinline=1`}
      className="w-full aspect-video min-h-[200px] rounded-md border border-white/20"
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowFullScreen
    />
    <a href={`https://www.youtube.com/watch?v=${id}`} target="_blank" rel="noopener noreferrer"
      className="inline-block border border-cyan-400 text-cyan-300 px-4 py-2 text-xs uppercase">
      Ver en YouTube
    </a>
  </div>;
}
